export enum CreditRequestClassificationEnum {
  IMPROVEMENT = 'IMPROVEMENT',
  BUG_CRITICAL_ERROR = 'BUG_CRITICAL_ERROR',
  BUG_MAJOR_ERROR = 'BUG_MAJOR_ERROR',
  BUG_OTHER_ERROR = 'BUG_OTHER_ERROR',
  BUG_UPDATE_ERROR = 'BUG_UPDATE_ERROR'
}
